// extracted by mini-css-extract-plugin
module.exports = {"center":"ServerError_center__3M9bu","errorCode":"ServerError_errorCode__vdSId","errorDesc":"ServerError_errorDesc__tAENh"};